<script>
  import { createEventDispatcher } from "svelte";
  import { ALL, RADICAL, KANJI, VOCABULARY } from "./constants.js";

  let activeSection = ALL;

  function setActive(section) {
    activeSection = section;
    changeView(section);
  }

  const dispatch = createEventDispatcher();

  function changeView(newView) {
    dispatch("viewChange", {
      view: newView
    });
  }
</script>

<style>
  ul {
    display: flex;
    padding: 0;
    flex-direction: row-reverse;
  }

  li {
    font-weight: bold;
    font-size: 1.3rem;
    list-style: none;
    margin-right: 1rem;
  }

  button {
    align-items: center;
    border: none;
    border-radius: 0;
    background: none;
    cursor: pointer;
    display: flex;
    flex: 1;
    margin: 0 0.5rem;
    padding: 0.5rem 0.25rem;
    transition: color 0.3s;
  }

  .radical {
    color: var(--blue);
  }

  .radical:hover {
    color: var(--blue-hover);
  }

  .kanji {
    color: var(--pink);
  }

  .kanji:hover {
    color: var(--pink-hover);
  }

  .vocabulary {
    color: var(--purple);
  }

  .vocabulary:hover {
    color: var(--purple-hover);
  }

  .all {
    color: var(--black);
  }

  .all:hover {
    color: var(--black-hover);
  }

  .active {
    border-bottom: 2px solid currentColor;
  }

  @media screen and (max-width: 768px) {
    ul {
      display: flex;
      flex: initial;
      padding: 0;
      flex-direction: column-reverse;
    }

    li {
      margin: 0.75rem 0;
    }
  }
</style>

<ul role="navigation">
  <li>
    <button
      class="vocabulary"
      class:active={activeSection === VOCABULARY}
      on:click={() => setActive(VOCABULARY)}>
      Vocabulary
    </button>
  </li>
  <li>
    <button
      class="kanji"
      class:active={activeSection === KANJI}
      on:click={() => setActive(KANJI)}>
      Kanji
    </button>
  </li>
  <li>
    <button
      class="radical"
      class:active={activeSection === RADICAL}
      on:click={() => setActive(RADICAL)}>
      Radicals
    </button>
  </li>
  <li>
    <button
      class="all"
      class:active={activeSection === ALL}
      on:click={() => setActive(ALL)}>
      All
    </button>
  </li>
</ul>
